import { render, staticRenderFns } from "./AddNewUserAdminModal.vue?vue&type=template&id=06e51f1a&"
import script from "./AddNewUserAdminModal.vue?vue&type=script&lang=ts&"
export * from "./AddNewUserAdminModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddNewUserAdminModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports